
import { CartItem, DeliveryDetails } from '../types';

export interface PaymentResponse {
  success: boolean;
  orderId?: string;
  redirectUrl?: string;
  error?: string;
}

export interface BillingDetails {
    nip: string;
    companyName: string;
    address: string;
}

export interface ShippingDetails {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    street: string;
    city: string;
    zipCode: string;
}

export const createPaymentOrder = async (
    cart: CartItem[], 
    totalAmount: number, 
    delivery?: DeliveryDetails,
    billing?: BillingDetails,
    shipping?: ShippingDetails
): Promise<PaymentResponse> => {
    
    console.log('[PaymentService] Initiating order creation via API...');

    try {
        // Direct POST request to the PHP backend
        const response = await fetch('api/create.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                cart: cart, 
                amount: totalAmount,
                delivery: delivery,
                billing: billing,
                shipping: shipping
            })
        });

        if (!response.ok) {
            const text = await response.text();
            console.error('[PaymentService] API Error:', text);
            throw new Error(`Server responded with ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.success) {
            console.log('[PaymentService] Order created successfully:', data.orderId);
            return { 
                success: true, 
                redirectUrl: data.redirectUrl || '/dziekujemy',
                orderId: data.orderId
            };
        } else {
            return { success: false, error: data.error || 'Wystąpił błąd podczas tworzenia zamówienia.' };
        }

    } catch (e) {
        console.error('[PaymentService] Network or Parse Error:', e);
        // Fallback is REMOVED to force debugging of the real backend connection.
        return { success: false, error: 'Błąd połączenia z serwerem. Sprawdź konsolę.' };
    }
};
